import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.components.facilitatorPromotionNotice.title',
    defaultMessage: "Congratulations! You've completed the course.",
    description: 'Title of the one-time modal announcing that the learner has become a Facilitator',
  },
  text: {
    id: 'portal.components.facilitatorPromotionNotice.text',
    defaultMessage: "You've successfully become a Facilitator and can now create and manage your own cohort.",
    description: 'Body of the one-time modal announcing that the learner has become a Facilitator',
  },
  cta: {
    id: 'portal.components.facilitatorPromotionNotice.cta',
    defaultMessage: 'Learn more',
    description: 'Label of the button that takes a newly promoted facilitator to the cohorts page',
  },
  dismiss: {
    id: 'portal.components.facilitatorPromotionNotice.dismiss',
    defaultMessage: 'Close',
    description: 'Label of the button that dismisses the facilitator promotion notice',
  },
});

export default messages;
